import PropTypes from 'prop-types';

import { MEDIA_TYPES } from '@/common/constants';

export const CustomDefaultProps = {
  alt: null,
  path: null,
  type: MEDIA_TYPES.IMAGE,
};

export const CustomPropTypes = {
  alt: PropTypes.string,
  path: PropTypes.string,
  type: PropTypes.oneOf([MEDIA_TYPES.IMAGE, MEDIA_TYPES.VIDEO]),
};
